import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Cliente } from '../../views/ABC/utils/models/ABC';

@Injectable({
  providedIn: 'root'
})
export class ClientePedidoService {
  private clienteSubject = new BehaviorSubject<Cliente>({ ClienteID: '', Nombre: '' })
  cliente$ = this.clienteSubject.asObservable();

  constructor() { }

  actualizarCliente(cliente: Cliente) {
    this.clienteSubject.next(cliente);
  }
  
  actualizarId(id: string) {
    const valorActual = this.clienteSubject.getValue();
    this.clienteSubject.next({...valorActual, ClienteID: id});
  }

  actualizarNombre(nombre: string) {
    const valorActual = this.clienteSubject.getValue();
    this.clienteSubject.next({...valorActual, Nombre: nombre});
  }

  resetCliente() {
    this.clienteSubject.next({ ClienteID: '', Nombre: '' })
  }
}
